import React, {Component} from "react";
import {Container, Row, Col} from "reactstrap";

class PageError extends Component {
    render() {
        let details =  this.props.location.state ? this.props.location.state.details : "";
        return (
            <div>
                <div className="app flex-row align-items-center bg-image">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md="6">
                                <div className="clearfix">
                                    <h1 className="float-left display-3 mr-4">Error</h1>
                                    <h4 className="pt-3">Oops something has gone wrong.</h4>
                                    <p className="text-muted float-left">{details}</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

export default PageError;
